import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import "../styles/Home.css";
import { Link } from "react-router-dom";
import API_BASE_URL from "../api";
import SEO from "../components/SEO";

const Home = () => {
  // ============================================
  // STATE MANAGEMENT
  // ============================================
  const [latestJobs, setLatestJobs] = useState([]);
  const [admitCards, setAdmitCards] = useState([]);
  const [admissionForms, setAdmissionForms] = useState([]);
  const [results, setResults] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);

  // ============================================
  // FETCH LATEST JOBS
  // ============================================
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/latest-jobs`)
      .then((res) => res.json())
      .then((data) => {
        console.log("Latest Jobs:", data);
        if (Array.isArray(data)) {
          setLatestJobs(data);
        } else {
          console.error("Unexpected response:", data);
          setLatestJobs([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching latest jobs:", err);
        setLatestJobs([]);
      });
  }, []);

  // ============================================
  // FETCH ADMIT CARDS
  // ============================================
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/admit-cards`)
      .then((res) => res.json())
      .then((data) => {
        console.log("Admit Cards:", data);
        console.log("Number of records:", data.length);
        if (Array.isArray(data)) {
          setAdmitCards(data);
        } else {
          console.error("Unexpected response:", data);
          setAdmitCards([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching admit cards:", err);
        setAdmitCards([]);
      });
  }, []);

  // ============================================
  // FETCH ADMISSION FORMS
  // ============================================
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/admission-forms`)
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setAdmissionForms(data.slice(0, 5));
        }
      })
      .catch((err) => {
        console.error("Error fetching admission forms:", err);
        setAdmissionForms([]);
      });
  }, []);

  // ============================================
  // FETCH RESULTS
  // ============================================
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/results`)
      .then((res) => res.json())
      .then((data) => {
        console.log("Results:", data);
        if (Array.isArray(data)) {
          setResults(data);
        } else {
          console.error("Unexpected response:", data);
          setResults([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching results:", err);
        setResults([]);
      });
  }, []);

  // ============================================
  // MODAL HANDLER
  // ============================================
  const openModal = (item, type) => {
    setSelectedItem({
      ...item,
      type,
    });
  };

  // ============================================
  // RENDER
  // ============================================
  return (
     
    <><SEO
      title="Latest Government Jobs 2026 | Sarkari Career Info"
      description="Latest Government Jobs, Results, Admit Cards, Answer Keys, Syllabus and Notifications."
      keywords="government jobs, sarkari jobs, latest jobs, admit card, results"
      url="https://sarkaricareerinfo.com/" />
      <div>
        {/* ===== LATEST JOBS SECTION ===== */}
        <section className="latest-jobs equal-width-section">
          <h2 className="section-title">Latest Jobs</h2>

          {/* Desktop View */}
          <div className="desktop-jobs">
            <div className="job-row">
              {latestJobs.slice(0, 5).map((job) => (
                <div
                  key={job.id}
                  className="job-card"
                  onClick={() => openModal(job, "job")}
                >
                  <div className="organization-tag">
                    <h2>{job.organization_name || "Organization"}</h2>
                  </div>
                  <h3 className="job-title">
                    {job.post_name || "Post Name Not Available"}
                  </h3>
                  <p>
                    <strong>Vacancies:</strong>{" "}
                    {job.total_vacancies || "Not Specified"}
                  </p>
                  <p>
                    <strong>Last Date:</strong> {job.last_date || "Not Available"}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Mobile View */}
          <div className="mobile-jobs-container">
            <div className="mobile-job-header">Latest Job Notifications</div>
            <div className="mobile-job-list">
              {latestJobs.slice(0, 5).map((job) => (
                <div
                  key={job.id}
                  className="mobile-job-item"
                  onClick={() => openModal(job, "job")}
                >
                  <div className="mobile-job-title">
                    • {job.post_name || "Post Name Not Available"} -{" "}
                    {job.organization_name || "Organization"}
                  </div>
                  <div className="mobile-job-details">
                    <span>Vacancies: {job.total_vacancies || "Not Specified"}</span>
                    <span>Last Date: {job.last_date || "Not Available"}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* View All Button */}
          <div className="view-all-container">
            <Link to="/latest-jobs" className="view-all-btn">
              View All →
            </Link>
          </div>
        </section>

        {/* ===== ADMIT CARDS SECTION ===== */}
        <section className="admit-cards equal-width-section">
          <h2 className="section-title">Admit Cards Details</h2>

          {/* Desktop View */}
          <div className="desktop-cards">
            <div className="card-row">
              {admitCards.map((card) => (
                <div
                  key={card.id}
                  className="admit-card"
                  onClick={() => openModal(card, "admit_card")}
                >
                  <div className="organization-tag">
                    <h2>{card.organization || "Organization"}</h2>
                  </div>
                  <h3 className="card-title">
                    {card.admit_name || "Exam Name Not Available"}
                  </h3>
                  <p>
                    <strong>Exam Date:</strong> {card.exam_date || "Not Available"}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Mobile View */}
          <div className="mobile-cards-container">
            <div className="mobile-card-header">Admit Cards Details</div>
            <div className="mobile-card-list">
              {admitCards.slice(0, 5).map((card) => (
                <div
                  key={card.id}
                  className="mobile-card-item"
                  onClick={() => openModal(card, "admit_card")}
                >
                  <div className="mobile-card-title">
                    • {card.admit_name || "Exam Name Not Available"} -{" "}
                    {card.organization || "Organization"}
                  </div>
                  <div className="mobile-card-details">
                    <span>Exam Date: {card.exam_date || "Not Available"}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* View All Button */}
          <div className="view-all-container">
            <Link to="/admit-cards" className="view-all-btn">
              View All →
            </Link>
          </div>
        </section>

        {/* ===== RESULTS SECTION ===== */}
        <section className="results equal-width-section">
          <h2 className="section-title">Results</h2>

          {/* Desktop View */}
          <div className="desktop-results">
            <div className="result-row">
              {results.slice(0, 5).map((result) => (
                <div
                  key={result.id}
                  className="result-card"
                  onClick={() => openModal(result, "result")}
                >
                  <div className="organization-tag">
                    <h2>{result.organization_name || "Organization"}</h2>
                  </div>
                  <h3 className="result-title">
                    {result.exam_name || "Result Name Not Available"}
                  </h3>
                  <p>
                    <strong>Result Date:</strong>{" "}
                    {result.result_date || "Not Available"}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Mobile View */}
          <div className="mobile-results-container">
            <div className="mobile-result-header">Results</div>
            <div className="mobile-result-list">
              {results.slice(0, 5).map((result) => (
                <div
                  key={result.id}
                  className="mobile-result-item"
                  onClick={() => openModal(result, "result")}
                >
                  <div className="mobile-result-title">
                    • {result.exam_name || "Result Name Not Available"} -{" "}
                    {result.organization_name || "Organization"}
                  </div>
                  <div className="mobile-result-details">
                    <span>Result Date: {result.result_date || "Not Available"}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* View All Button */}
          <div className="view-all-container">
            <Link to="/results" className="view-all-btn">
              View All →
            </Link>
          </div>
        </section>

        {/* ===== MODAL SECTION ===== */}
        {selectedItem && (
          <div
            className="modal-overlay"
            onClick={() => setSelectedItem(null)}
          >
            <div
              className="modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close Button */}
              <button
                className="close-btn"
                onClick={() => setSelectedItem(null)}
              >
                ✕
              </button>

              {/* Modal Header */}
              <div className="modal-header">
                <span className="modal-badge">{selectedItem.type}</span>
                <h2>
                  {selectedItem.post_name ||
                    selectedItem.job_post ||
                    selectedItem.exam_name ||
                    selectedItem.admit_name ||
                    "Notification"}
                </h2>
              </div>

              {/* Modal Body */}
              <div className="modal-body">
                {selectedItem.organization_name && (
                  <p className="detail-row">
                    <strong>Organization</strong>
                    <span>{selectedItem.organization_name}</span>
                  </p>
                )}

                {selectedItem.post_name && (
                  <p className="detail-row">
                    <strong>Post Name</strong>
                    <span>{selectedItem.post_name}</span>
                  </p>
                )}
                {selectedItem.post_date && (
                  <p className="detail-row">
                    <strong>Post Date</strong>
                    <span>{selectedItem.post_date}</span>
                  </p>
                )}
                {selectedItem.admit_name && (
                  <p className="detail-row">
                    <strong>Admit Card Name</strong>
                    <span>{selectedItem.admit_name}</span>
                  </p>
                )}

                {selectedItem.exam_name && (
                  <p className="detail-row">
                    <strong>Exam Name</strong>
                    <span>{selectedItem.exam_name}</span>
                  </p>
                )}

                {selectedItem.total_vacancies && (
                  <p className="detail-row">
                    <strong>Total Vacancies</strong>
                    <span>{selectedItem.total_vacancies}</span>
                  </p>
                )}

                {selectedItem.pay_scale && (
                  <p className="detail-row">
                    <strong>Pay Scale</strong>
                    <span>{selectedItem.pay_scale}</span>
                  </p>
                )}

                {selectedItem.application_start_date && (
                  <p className="detail-row">
                    <strong>Application Start Date</strong>
                    <span>{selectedItem.application_start_date}</span>
                  </p>
                )}

                {selectedItem.last_date && (
                  <p className="detail-row">
                    <strong>Last Date</strong>
                    <span>{selectedItem.last_date}</span>
                  </p>
                )}



                {selectedItem.exam_date && (
                  <p className="detail-row">
                    <strong>Exam Date</strong>
                    <span>{selectedItem.exam_date}</span>
                  </p>
                )}

                {selectedItem.result_date && (
                  <p className="detail-row">
                    <strong>Result Date</strong>
                    <span>{selectedItem.result_date}</span>
                  </p>
                )}
              </div>

              {/* Modal Action Button */}

              <Link
                to={`/info/${selectedItem.type}/${selectedItem.slug}`}
                className="notification-btn"
              >
                View Full Details
              </Link>

              {/* {selectedItem.notification_pdf && (
              <a
                href={selectedItem.notification_pdf}
                target="_blank"
                rel="noopener noreferrer"
                className="notification-btn"
                onClick={(e) => e.stopPropagation()}
              >
                View Full Notification
              </a>
            )} */}

              {selectedItem.download_link && (
                <a
                  href={selectedItem.download_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="notification-btn"
                  onClick={(e) => e.stopPropagation()}
                >
                  Download Admit Card
                </a>
              )}
            </div>
          </div>
        )}
      </div>
      </>
  );
};

export default Home;